/**
 * @file Frontend utilities — fetchUnitIdToSymbolMap.ts.
 */

import axiosClient from "../api/axiosClient";
import { formatUnitSymbol } from "./formatUnitSymbol";

type UnitLike = {
  id?: unknown;
  symbol?: unknown;
  unitSymbol?: unknown;
  name?: unknown;
  displayName?: unknown;
};

/**
 * Flatten GET /units response into id → display symbol (for Background `subMaterialUnit` ids).
 */
export async function fetchUnitIdToSymbolMap(): Promise<Record<number, string>> {
  const idToSymbol: Record<number, string> = {};
  try {
    const res = await axiosClient.get("/units");
    const raw = res?.data?.data ?? res?.data;
    const consumeUnit = (u: UnitLike) => {
      if (u?.id == null) return;
      const id = Number(u.id);
      if (!Number.isFinite(id)) return;
      const label =
        String(u.symbol ?? "").trim() ||
        String(u.unitSymbol ?? "").trim() ||
        String(u.displayName ?? "").trim() ||
        String(u.name ?? "").trim();
      if (label) idToSymbol[id] = formatUnitSymbol(label);
    };
    if (Array.isArray(raw)) {
      raw.forEach((propertyOrUnit: { units?: unknown[] }) => {
        if (Array.isArray(propertyOrUnit?.units)) {
          propertyOrUnit.units!.forEach((u) => consumeUnit(u as UnitLike));
        } else {
          consumeUnit(propertyOrUnit as UnitLike);
        }
      });
    } else if (raw && Array.isArray((raw as { units?: unknown[] }).units)) {
      (raw as { units: unknown[] }).units.forEach((u) =>
        consumeUnit(u as UnitLike)
      );
    }
  } catch {
    // ignore
  }
  return idToSymbol;
}
